var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserNonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1341 9.05866C10.0508 9.05033 9.95078 9.05033 9.85911 9.05866C7.87578 8.99199 6.30078 7.36699 6.30078 5.36699C6.30078 3.32533 7.95078 1.66699 10.0008 1.66699C12.0424 1.66699 13.7008 3.32533 13.7008 5.36699C13.6924 7.36699 12.1174 8.99199 10.1341 9.05866Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1341 9.05866C10.0508 9.05033 9.95078 9.05033 9.85911 9.05866C7.87578 8.99199 6.30078 7.36699 6.30078 5.36699C6.30078 3.32533 7.95078 1.66699 10.0008 1.66699C12.0424 1.66699 13.7008 3.32533 13.7008 5.36699C13.6924 7.36699 12.1174 8.99199 10.1341 9.05866Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.96758 12.133C3.95091 13.483 3.95091 15.683 5.96758 17.0247C8.25924 18.558 12.0176 18.558 14.3092 17.0247C16.3259 15.6747 16.3259 13.4747 14.3092 12.133C12.0259 10.608 8.26758 10.608 5.96758 12.133Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96758 12.133C3.95091 13.483 3.95091 15.683 5.96758 17.0247C8.25924 18.558 12.0176 18.558 14.3092 17.0247C16.3259 15.6747 16.3259 13.4747 14.3092 12.133C12.0259 10.608 8.26758 10.608 5.96758 12.133Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserNonActive);
export default __webpack_public_path__ + "static/media/profile-user-non-active.d2d2ab61c5402b2f32a13f7e9b385063.svg";
export { ForwardRef as ReactComponent };